import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SupportEmailRequest } from '../support-email-request.model';

@Injectable({
    providedIn: 'root',
})
export class CustomerSupportService {
    constructor(private httpClient: HttpClient) {}

    sendEmail$(supportEmailRequest: SupportEmailRequest): Observable<void> {
        return this.httpClient.post<void>(`/api/customer_support/email`, supportEmailRequest);
    }
}
